var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_1276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48578 0 0 4.48578 0 10C0 15.5142 4.48578 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48578 15.5142 0 10 0Z",
    fill: "#36B18D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0692 7.88086L9.6525 13.2974C9.48999 13.4599 9.27667 13.5417 9.06335 13.5417C8.85004 13.5417 8.63672 13.4599 8.47421 13.2974L5.76593 10.5891C5.44 10.2634 5.44 9.73663 5.76593 9.41086C6.09171 9.08493 6.61829 9.08493 6.94421 9.41086L9.06335 11.53L13.8909 6.70258C14.2167 6.37665 14.7433 6.37665 15.0692 6.70258C15.395 7.02835 15.395 7.55493 15.0692 7.88086Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_1276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.db57e1b5b37a5fc43e42606857ee4f62.svg";
export { ForwardRef as ReactComponent };